import { render } from "./invoiceAdd.vue?vue&type=template&id=bb9a506c&scoped=true"
import script from "./invoiceAdd.vue?vue&type=script&lang=js"
export * from "./invoiceAdd.vue?vue&type=script&lang=js"

import "./invoiceAdd.vue?vue&type=style&index=0&id=bb9a506c&lang=scss&scoped=true"
import "./invoiceAdd.vue?vue&type=style&index=1&id=bb9a506c&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb9a506c"]])

export default __exports__